import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Calendar, TrendingUp, Award, Plus, BarChart, UserPlus, Bell, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { useAuth } from '../../contexts/AuthContext';
export function ChapterDashboard() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const stats = [{
    label: 'Total Anggota',
    value: '245',
    trend: '+12 bulan ini',
    trendUp: true,
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Acara Aktif',
    value: '8',
    trend: '3 mendatang',
    trendUp: true,
    icon: Calendar,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Tingkat Engagement',
    value: '78%',
    trend: '+5% dari bulan lalu',
    trendUp: true,
    icon: TrendingUp,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Sertifikat Diterbitkan',
    value: '156',
    trend: 'Tahun ini',
    trendUp: true,
    icon: Award,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const recentMembers = [{
    name: 'Ahmad Rizki',
    email: 'ahmad@example.com',
    joinDate: '2 hari lalu',
    status: 'active'
  }, {
    name: 'Siti Rahayu',
    email: 'siti@example.com',
    joinDate: '5 hari lalu',
    status: 'active'
  }, {
    name: 'Budi Hartono',
    email: 'budi@example.com',
    joinDate: '1 minggu lalu',
    status: 'pending'
  }];
  const upcomingEvents = [{
    id: 1,
    title: 'Workshop React',
    date: '15 Jan 2025',
    registered: 28,
    capacity: 30
  }, {
    id: 2,
    title: 'Meetup Bulanan',
    date: '22 Jan 2025',
    registered: 45,
    capacity: 50
  }, {
    id: 3,
    title: 'Hackathon 2025',
    date: '5 Feb 2025',
    registered: 67,
    capacity: 100
  }];
  return <div className="min-h-screen bg-white" data-id="element-1366">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1367">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1368">
          <div data-id="element-1369">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1370">
              Dasbor Chapter
            </h1>
            <p className="text-sm sm:text-base text-neutral-600" data-id="element-1371">
              {user?.chapterName || 'Jakarta Tech Community'} - Kelola aktivitas
              chapter Anda
            </p>
          </div>
          <div className="flex gap-2 sm:gap-3" data-id="element-1372">
            <Button variant="secondary" size="sm" onClick={() => navigate('/announcements')} className="flex-1 sm:flex-none" data-id="element-1373">
              <Bell className="w-4 h-4 sm:mr-2" data-id="element-1374" />
              <span className="hidden sm:inline" data-id="element-1375">Pengumuman</span>
              <span className="sm:hidden" data-id="element-1376">Info</span>
            </Button>
            <Button size="sm" onClick={() => navigate('/events/create')} className="flex-1 sm:flex-none" data-id="element-1377">
              <Plus className="w-4 h-4 sm:mr-2" data-id="element-1378" />
              <span className="hidden sm:inline" data-id="element-1379">Buat Acara</span>
              <span className="sm:hidden" data-id="element-1380">Acara</span>
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-1381">
          {stats.map((stat, i) => <Card key={i} data-id="element-1382">
              <CardContent className="p-4 sm:p-6" data-id="element-1383">
                <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-1384">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-1385">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-1386" />
                  </div>
                  {stat.trendUp && <TrendingUp className="w-4 h-4 text-success" data-id="element-1387" />}
                </div>
                <div className="space-y-1" data-id="element-1388">
                  <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900" data-id="element-1389">
                    {stat.value}
                  </h3>
                  <p className="text-xs sm:text-sm text-neutral-600" data-id="element-1390">
                    {stat.label}
                  </p>
                </div>
                <p className="text-xs mt-2 sm:mt-3 text-success" data-id="element-1391">
                  {stat.trend}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-1392">
          {/* Recent Members */}
          <Card data-id="element-1393">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1394">
              <CardTitle className="text-base sm:text-lg" data-id="element-1395">
                Anggota Terbaru
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/chapter/members')} data-id="element-1396">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1397">
              <div className="overflow-x-auto -mx-4 sm:mx-0" data-id="element-1398">
                <div className="inline-block min-w-full align-middle" data-id="element-1399">
                  <Table data-id="element-1400">
                    <TableHeader data-id="element-1401">
                      <TableRow data-id="element-1402">
                        <TableHead className="text-xs sm:text-sm" data-id="element-1403">
                          Nama
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-1404">
                          Bergabung
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-1405">
                          Status
                        </TableHead>
                        <TableHead className="text-right text-xs sm:text-sm" data-id="element-1406">
                          Aksi
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody data-id="element-1407">
                      {recentMembers.map((member, i) => <TableRow key={i} data-id="element-1408">
                          <TableCell data-id="element-1409">
                            <div data-id="element-1410">
                              <p className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-1411">
                                {member.name}
                              </p>
                              <p className="text-xs text-neutral-500" data-id="element-1412">
                                {member.email}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell className="text-neutral-600 text-xs sm:text-sm" data-id="element-1413">
                            {member.joinDate}
                          </TableCell>
                          <TableCell data-id="element-1414">
                            <Badge variant={member.status === 'active' ? 'success' : 'warning'} className="text-xs" data-id="element-1415">
                              {member.status === 'active' ? 'AKTIF' : 'MENUNGGU'}
                            </Badge>
                          </TableCell>
                          <TableCell className="text-right" data-id="element-1416">
                            <Button size="sm" variant="secondary" className="text-xs" data-id="element-1417">
                              Lihat
                            </Button>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Upcoming Events */}
          <Card data-id="element-1418">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1419">
              <CardTitle className="text-base sm:text-lg" data-id="element-1420">
                Acara Mendatang
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/events')} data-id="element-1421">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1422">
              <div className="space-y-3 sm:space-y-4" data-id="element-1423">
                {upcomingEvents.map(event => <div key={event.id} className="flex items-center justify-between p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all cursor-pointer" onClick={() => navigate(`/events/${event.id}`)} data-id="element-1424">
                    <div data-id="element-1425">
                      <h4 className="font-medium text-sm sm:text-base text-neutral-900" data-id="element-1426">
                        {event.title}
                      </h4>
                      <p className="text-xs sm:text-sm text-neutral-600" data-id="element-1427">
                        {event.date}
                      </p>
                    </div>
                    <div className="text-right" data-id="element-1428">
                      <p className="text-sm font-medium text-neutral-900" data-id="element-1429">
                        {event.registered}/{event.capacity}
                      </p>
                      <p className="text-xs text-neutral-500" data-id="element-1430">terdaftar</p>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-1431">
          <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-4" data-id="element-1432">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-1433">
            {[{
            label: 'Tambah Anggota',
            icon: UserPlus,
            onClick: () => navigate('/chapter/members/add')
          }, {
            label: 'Buat Acara',
            icon: Calendar,
            onClick: () => navigate('/events/create')
          }, {
            label: 'Lihat Laporan',
            icon: BarChart,
            onClick: () => navigate('/chapter/reports')
          }, {
            label: 'Kirim Pengumuman',
            icon: Bell,
            onClick: () => navigate('/announcements/create')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-1434">
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-1435" />
                <span className="text-xs sm:text-sm text-center" data-id="element-1436">
                  {action.label}
                </span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}